"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttachmentClient = useAttachmentClient;
const AttachmentClient_1 = require("@juvare/platform-sdk-js/AttachmentClient");
const react_1 = __importDefault(require("react"));
function useAttachmentClient(baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new AttachmentClient_1.AttachmentClient(baseUrl, tokenProvider), [baseUrl, tokenProvider]);
}
